import {
  createErrorType,
  createFetchType,
  createLoadingType,
  createSuccessType,
} from '../actionHelpers';

// legacy order
const LEGACY_ORDERS_SCOPE = 'LEGACY_ORDERS';
export const FETCH_LEGACY_ORDERS = createFetchType(LEGACY_ORDERS_SCOPE);
export const FETCH_LEGACY_ORDERS_SUCCESS = createSuccessType(
  LEGACY_ORDERS_SCOPE,
);
export const FETCH_LEGACY_ORDERS_ERROR = createErrorType(LEGACY_ORDERS_SCOPE);
export const FETCH_LEGACY_ORDERS_LOADING = createLoadingType(
  LEGACY_ORDERS_SCOPE,
);
